/*---------------------------------------------------------------------------
 The following JavaScript functions for Challenges client side functions
-----------------------------------------------------------------------------*/

// Generic page functions
var TECL_ChallengesGeneric = {

    // Setup the new challenge and call the page
    CreateNewChallenge: function() {

        if (TECL_Master.AddLock("TECL_ChallengesGeneric.CreateNewChallenge")) {
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/CreateNewChallenge",
                dataType: "json",
                type: "POST",
                error: function(exc) {
                    TECL_Master.ClearLock("TECL_ChallengesGeneric.CreateNewChallenge");
                },
                success: function(redirectUrl) {
                    TECL_Master.ClearLock("TECL_ChallengesGeneric.CreateNewChallenge");
                    if (redirectUrl) {
                        window.location = redirectUrl;
                    }
                }
            });
        }
    },

    // Validate a text control
    ValidateStringControl: function(stringControlId, errorControl) {
        var isValid = true;
        var controlVal = $("#" + stringControlId).val();
        if (controlVal && controlVal.length > 0) {
            $("#" + errorControl).addClass("hidden");
        } else {
            isValid = false;
            $("#" + errorControl).removeClass("hidden");
        }
        return isValid;
    }

};

// Creation page functions
var TECL_ChallengeCreation = {

    // Continue button click handler
    ContinueSelected: function() {

        if (TECL_Master.AddLock("TECL_ChallengeCreation.ContinueSelected")) {
            var isValid = TECL_ChallengeCreation.ValidatePage();

            if (isValid) {
                var cacheKeyIdVal = $("#CacheKeyId").val();
                var titleVal = $("#challengeTitle").val();
                var descriptionVal = $("#challengeDescription").val();

                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/ContinueFromCreatorStage",
                    dataType: "json",
                    type: "POST",
                    data: {
                        cacheKeyId: cacheKeyIdVal,
                        title: titleVal,
                        description: descriptionVal
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengeCreation.ContinueSelected");
                    },
                    success: function(redirectUrl) {
                        TECL_Master.ClearLock("TECL_ChallengeCreation.ContinueSelected");
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    }
                });
            }
        }
    },

    // Validate data on the page
    ValidatePage: function() {
        var isValid = true;

        if (!TECL_ChallengesGeneric.ValidateStringControl("challengeTitle", "errChallengeTitle")) {
            isValid = false;
        }
        return isValid;
    }

};

// Creation user details page functions
var TECL_ChallengeUserDetails = {

    // Continue button click handler
    ContinueSelected: function() {

        if (TECL_Master.AddLock("TECL_ChallengeUserDetails.ContinueSelected")) {
            var isValid = TECL_ChallengeUserDetails.ValidatePage();

            if (isValid) {
                var cacheKeyIdVal = $("#CacheKeyId").val();
                var pageValues = TECL_ChallengeUserDetails.SerialisedData();

                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/ContinueFromUserDetailsStage",
                    dataType: "json",
                    type: "POST",
                    data: {
                        cacheKeyId: cacheKeyIdVal,
                        firstName: pageValues.FirstName,
                        lastName: pageValues.LastName,
                        emailAddress: pageValues.EmailAddress,
                        password: pageValues.Password,
                        jobTypeId: pageValues.JobTypeId,
                        organisationId: pageValues.OrganisationId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.ContinueSelected");
                    },
                    success: function(redirectUrl) {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.ContinueSelected");
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    }
                });
            } else {
                TECL_Master.ClearLock("TECL_ChallengeUserDetails.ContinueSelected");
            }
        }
    },

    // Get the Serialised Data
    SerialisedData: function() {

        //get standard data
        var firstName = $("#userFirstNameVal").val();
        var lastName = $("#userLastNameVal").val();
        var jobTypeId = $("#ddlPositions").val();
        var emailAddress = $("#userEmailAddressVal").val();
        var password = $("#userPasswordVal").val();

        var organisationId;
        var organisationName;
        if ($("#ddlOrganisations").length > 0) {
            organisationId = $("#ddlOrganisations").val();
            organisationName = $("#ddlOrganisations").data("kendoDropDownList").text();
        } else {
            organisationId = $("#userOrganisationIdVal").val();
            organisationName = $("#userOrganisationNameVal").val();
        }

        if (organisationId == null || organisationId == "") {
            organisationId = $("#orgId").val();
        }

        if (organisationName == "" && $("#schoolSearch").attr("data_name") != "") {
            organisationName = $("#schoolSearch").attr("data_name");
        }

        var userInfoData = {
            FirstName: firstName,
            LastName: lastName,
            OrganisationId: organisationId,
            OrganisationName: organisationName,
            JobTypeId: jobTypeId,
            EmailAddress: emailAddress,
            Password: password
        }
        return userInfoData;
    },

    // Validate data on the page
    ValidatePage: function() {
        var isValid = true;
        TECL_ChallengeUserDetails.ClearValidationErrors();

        // Validate the first name
        if (!TECL_ChallengesGeneric.ValidateStringControl("userFirstNameVal", "errUserDetailsFirstName")) {
            isValid = false;
        }

        // Validate the last name
        if (!TECL_ChallengesGeneric.ValidateStringControl("userLastNameVal", "errUserDetailsLastName")) {
            isValid = false;
        }

        // Validate organistion details
        var organisationId = $("#userOrganisationIdVal").val();
        var ddlOrganisationId = $("#ddlOrganisations").val();

        if (organisationId == null || organisationId == "") {
            organisationId = $("#orgId").val();
        }

        if ((organisationId == null || organisationId <= 0) && ddlOrganisationId == null) {
            $("#errUserDetailsOrganisation").removeClass("hidden");
            isValid = false;
        }

        // Validate job title
        var positionId = $("#ddlPositions").val();
        if (!positionId) {
            $("#errUserDetailsPosition").removeClass("hidden");
            isValid = false;
        }

        // Validate email address
        var emailAddress = $("#userEmailAddressVal").val();
        var confirmEmailAddress = $("#userConfirmEmailAddressVal").val();

        if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {
            $("#errUserDetailsEmailAddress").removeClass("hidden");
            isValid = false;

        } else if (TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists(null, emailAddress)) {
            $("#errUserDetailsUsedEmailAddress").removeClass("hidden");
            noErrors = false;

        } else if (emailAddress !== confirmEmailAddress) {
            $("#errUserDetailsConfirmEmailAddress").removeClass("hidden");
            isValid = false;
        }

        // Validate password
        var passwordSection = $("#passwordSection");
        if (passwordSection.length > 0) {

            var password = $("#userPasswordVal").val();
            var confirmPassword = $("#userConfirmPasswordVal").val();

            if (!password || password.length < 5) {
                $("#errUserDetailsPassword").removeClass("hidden");
                isValid = false;

            } else if (password !== confirmPassword) {
                $("#errUserDetailsConfirmPassword").removeClass("hidden");
                isValid = false;
            }
        }

        return isValid;
    },

    // Search for a organisation
    OrganisationSearch: function() {
        if (TECL_Master.AddLock("TECL_ChallengeUserDetails.OrganisationSearch")) {
            TECL_ChallengeUserDetails.ClearValidationErrors();

            var searchText = $("#userOrganisationNameVal").val();
            if (!searchText) {
                $("#errUserDetailsOrganisationSearch").removeClass("hidden");
            } else {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/Tender/OrganisationSearch",
                    type: "POST",
                    data: {
                        searchText: searchText
                    },
                    error: function() {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.OrganisationSearch");
                    },
                    success: function(partialViewHtml) {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.OrganisationSearch");
                        if (partialViewHtml) {
                            $("#OrganisationSearchResults").removeClass("hidden");
                            $("#OrganisationSearchResults").html(partialViewHtml);
                        }
                    }
                });
            }
        }
    },

    // Clear all validation error text
    ClearValidationErrors: function() {
        $("#errUserDetailsOrganisationNoSearchEntries").addClass("hidden");
        $("#errUserDetailsFirstName").addClass("hidden");
        $("#errUserDetailsLastName").addClass("hidden");
        $("#errUserDetailsOrganisation").addClass("hidden");
        $("#errUserDetailsOrganisationSearch").addClass("hidden");
        $("#errUserDetailsPosition").addClass("hidden");
        $("#errUserDetailsEmailAddress").addClass("hidden");
        $("#errUserDetailsUsedEmailAddress").addClass("hidden");
        $("#errUserDetailsConfirmEmailAddress").addClass("hidden");
        $("#errUserDetailsPassword").addClass("hidden");
        $("#errUserDetailsConfirmPassword").addClass("hidden");
        $("#errLoginEmailAddress").addClass("hidden");
        $("#errLoginPassword").addClass("hidden");
        $("#errLoginFail").addClass("hidden");
    },

    // Validate the login info and try and authenticate the details
    LogInUser: function() {

        if (TECL_Master.AddLock("TECL_ChallengeUserDetails.LogInUser")) {
            TECL_ChallengeUserDetails.ClearValidationErrors();

            var emailAddress = $("#loginEmailAddressVal").val();
            var password = $("#loginPasswordVal").val();

            var noErrors = true;

            if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {
                $("#errLoginEmailAddress").removeClass("hidden");
                noErrors = false;
            }

            if (!password) {
                $("#errLoginPassword").removeClass("hidden");
                noErrors = false;
            }

            if (noErrors) {
                var cacheId = $("#CacheKeyId").val();
      
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/AuthenticateUserDetails",
                    dataType: "json",
                    type: "POST",
                    data: {
                        cacheId: cacheId,
                        emailAddress: emailAddress,
                        password: password
                    },
                    error: function(err) {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.LogInUser");
                    },
                    success: function(viewModel) {
                        TECL_Master.ClearLock("TECL_ChallengeUserDetails.LogInUser");
                        if (viewModel && viewModel.ErrorCode === 0 && viewModel.RedirectUrl) {
                            // Reload the view so the correct data is displayed
                            window.location = viewModel.RedirectUrl;
                        } else {
                            $("#errLoginFail").removeClass("hidden");
                        }
                    }
                });
            } else {
                TECL_Master.ClearLock("TECL_ChallengeUserDetails.LogInUser");
            }
        }
    }

};

// Messaging page functions
var TECL_ChallengeMessaging = {

    // Animate the messages loading
    TriggerConversationAnimations: function() {
        var num_animated_messages = 8;
        var num_messages = $(".conversation-log").find(".conversation-message").length;
        $(".conversation-message").slice(0, num_messages - num_animated_messages).css({ "opacity": "1" });
        $(".conversation-log").animate({ scrollTop: $(".conversation-log")[0].scrollHeight }, 1000);

        TweenMax.staggerFromTo(
          $(".conversation-message").slice(-num_animated_messages),
          0.5,
          { ease: Power1.easeIn, x: -100 },
          { opacity: 1, x: 0 },
          0.1
        );
    },

    // Close a challenge
    CloseChallenge: function() {

        var challengeId = $("#challengeId").val();

        if (challengeId) {
            if (TECL_Master.AddLock("TECL_ChallengeMessaging.CloseChallenge")) {

                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/CloseChallenge",
                    type: "POST",
                    data: {
                        challengeId: challengeId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengeMessaging.CloseChallenge");
                    },
                    success: function(redirectUrl) {

                        TECL_Master.ClearLock("TECL_ChallengeMessaging.CloseChallenge");
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    }
                });
            }
        }
    },

    // Handle the change of supplier on the messaging page
    ConversationChanged: function() {
        var challengeId = $("#challengeId").val();
        var parentActivityId = $("#parentActivityId").val();

        var conversationId = $("#messageSupplierChanged").val();

        if (conversationId && challengeId) {
            if (TECL_Master.AddLock("TECL_ChallengeMessaging.ConversationChanged")) {

                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/ChangeSupplierConversation",
                    type: "POST",
                    data: {
                        activityId: challengeId,
                        parentActivityId: parentActivityId,
                        conversationId: conversationId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengeMessaging.ConversationChanged");
                    },
                    success: function(partialViewHtml) {
                        TECL_Master.ClearLock("TECL_ChallengeMessaging.ConversationChanged");
                        if (partialViewHtml) {
                            $("#messagesSection").html(partialViewHtml);
                            TECL_ChallengeMessaging.TriggerConversationAnimations();
                        } else {
                            $("#messagesSection").empty();
                        }
                    }
                });
            }
        }
    },

    // Add a new message item
    AddNewMessageItem: function() {
        var challengeId = $("#challengeId").val();
        var parentActivityId = $("#parentActivityId").val();
        var conversationId = $("#conversationId").val();
        var messageText = $("#newMessageText").val();

        if (conversationId && messageText && challengeId) {
            if (TECL_Master.AddLock("TECL_ChallengeMessaging.AddNewMessageItem")) {

                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/AddNewMessageItem",
                    type: "POST",
                    data: {
                        activityId: challengeId,
                        parentActivityId: parentActivityId,
                        conversationId: conversationId,
                        messageText: messageText
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengeMessaging.AddNewMessageItem");
                    },
                    success: function(partialViewHtml) {
                        TECL_Master.ClearLock("TECL_ChallengeMessaging.AddNewMessageItem");
                        if (partialViewHtml) {
                            $("#messagesSection").html(partialViewHtml);
                            TECL_ChallengeMessaging.TriggerConversationAnimations();
                        } else {
                            $("#messagesSection").empty();
                        }
                    }
                });
            }
        }
    }

};

// Handle file uploads and downloads
var TECL_ChallengesFileHandler = {

    // download a file
    DownloadFile: function(documentId) {
        window.location = baseSiteUrl + "umbraco/Surface/ChallengeSurface/DownloadFile?documentId=" + documentId;
    },

    // On successful upload of a proposal file
    OnSuccess_FileUpload: function(e) {
        if (TECL_Master.AddLock("TECL_ChallengesFileHandler_OnSuccess_FileUpload")) {

            if (e.operation == "upload" && e.files != null && e.files.length > 0) {
                var file = e.files[0].rawFile;
                var activityId = $("#challengeId").val();
                var isActiveValue = $("#isActive").val();

                var isActive = false;
                if (isActiveValue) {
                    isActive = true;
                }

                if (file) {
                    $.ajax({
                        url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/DisplayUploadFile",
                        type: "POST",
                        data: {
                            activityId: activityId,
                            fileName: file.name,
                            isActive: isActive
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("TECL_ChallengesFileHandler_OnSuccess_FileUpload");
                        },
                        success: function(html) {
                            TECL_Master.ClearLock("TECL_ChallengesFileHandler_OnSuccess_FileUpload");
                            if (html != null) {
                                var listContainer = $("#uploadedFiles");
                                $(html).appendTo(listContainer);
                                $("#uploadFilesListing").removeClass("hidden");
                            }
                        }
                    });
                }
            }
        }
    },

    // Remove the uploaded file
    RemoveFile: function(documentId, elementId) {
        if (TECL_Master.AddLock("TECL_ChallengesFileHandler_RemoveFile")) {
            var activityId = $("#challengeId").val();

            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/RemoveFile",
                type: "POST",
                data: {
                    activityId: activityId,
                    documentId: documentId
                },
                error: function(exc) {
                    TECL_Master.ClearLock("TECL_ChallengesFileHandler_RemoveFile");
                },
                success: function(result) {
                    TECL_Master.ClearLock("TECL_ChallengesFileHandler_RemoveFile");
                    if (result && result === true) {
                        $(elementId).remove();

                        var fileCount = $("#uploadedFiles").children().length;
                        if (fileCount < 1) {
                            $("#uploadFilesListing").addClass("hidden");
                        }
                    }
                }
            });
        }
    }

};

// Handles the conversation selector page functions
var TECL_ChallengesConversationSelector = {

    // Change the status of a supplier conversation
    ChangeSupplierState: function(status, supplierActivityId, rowElement) {
        if (TECL_Master.AddLock("TECL_ChallengesConversationSelector_ChangeSupplierState")) {

            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/ChangeSupplierState",
                type: "POST",
                data: {
                    status: status,
                    supplierActivityId: supplierActivityId
                },
                error: function(exc) {
                    TECL_Master.ClearLock("TECL_ChallengesConversationSelector_ChangeSupplierState");
                },
                success: function(result) {
                    TECL_Master.ClearLock("TECL_ChallengesConversationSelector_ChangeSupplierState");
                    if (result) {
                        // Change the close button to closed text
                        $(rowElement).find(".challengeCloseButton").addClass("hidden");
                        $(rowElement).find(".closedChallengeText").removeClass("hidden");
                    } else {
                        TECL_Master.ShowErrorDialog("Failed to close the conversation");
                    }
                }
            });
        }
    },

    // Display the file dowload dialog and show the case study file for the selected supplier
    DisplayDownloadFiles: function(conversationId) {
        if (conversationId) {

            if (TECL_Master.AddLock("TECL_ChallengesConversationSelector_DisplayDownloadFiles")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/ChallengeSurface/GetDownloadFileData",
                    type: "POST",
                    data: {
                        conversationId: conversationId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_ChallengesConversationSelector_DisplayDownloadFiles");
                    },
                    success: function(viewHtml) {
                        TECL_Master.ClearLock("TECL_ChallengesConversationSelector_DisplayDownloadFiles");
                        if (viewHtml) {
                            $("#DownloadFilesDialog").empty().html(viewHtml);
                            $("#tenderSupplierFileDownloadDialogData").modal("show");
                        }
                    }
                });
            }
        }
    }

};